// Il codice di una lead e l'indirizzo della sua pagina
// (segnalazione del cliente OwlCaveLabs/syndesia-l2c-support#14).
//
// Il codice non e' salvato da nessuna parte: il backend lo compone dall'id con
// `lead.codePrefix` e `lead.codeFill` di backend/config/index.js, e questi due
// valori devono restare uguali a quelli. La pagina si apre da `/l/syp00006`;
// `/l/6`, il formato dei link spediti prima (email, calendari, segnalibri),
// continua ad aprirla e il router lo riscrive nel codice.

const CODE_PREFIX = 'SYP';
const CODE_FILL = 5;

// Nella lettura il prefisso non conta: se un giorno cambiasse, i link gia'
// spediti con quello vecchio aprirebbero ancora la lead
const ROUTE_CODE = /^[a-z]*(\d+)$/i;

export function leadCode(id: number | string): string {
  return `${CODE_PREFIX}${String(id).padStart(CODE_FILL, '0')}`;
}

// Il parametro `code` della rotta Lead: il codice in minuscolo
export function leadRouteCode(id: number | string): string {
  return leadCode(id).toLowerCase();
}

// L'id della lead dal parametro della rotta, che sia il codice (`syp00006`,
// anche in maiuscolo) o l'id dei link vecchi (`6`). NaN se non e' fatto di
// lettere seguite da cifre, come il `Number()` di prima: la pagina si comporta
// come con un id inesistente.
export function leadIdFromRouteCode(code: string): number {
  const match = ROUTE_CODE.exec(code);

  return match ? Number(match[1]) : Number.NaN;
}
